import React, { useEffect, useState } from 'react'
import { CardBody } from 'reactstrap'
import { RootState } from 'index';
import { useDispatch, useSelector } from 'react-redux';
import { setVesselID } from 'Store/Generic/ReportingSlice';
import { Link } from 'react-router-dom';
import apiGlobal from 'global/api.global';
import { AdjustmentApprovalStatus } from 'shared/constants';

const PendingLNGCargoDetails = (vesselId: any) => {
    /** State variables */
    const dispatch = useDispatch();
    const { VesselID } = useSelector((state: RootState) => state.Reporting);
    const [tableDetails, setTableDetails] = useState<Array<any>>([]);
    /** State variables end */

    /** useEffect start */
    useEffect(() => {
        dispatch(setVesselID(vesselId?.VesselID));
    }, [vesselId, dispatch])
    /** useEffect end */

    /** Load N2 corrections of selected vessel pending for user approval */
    useEffect(() => {
        apiGlobal.get(`n2_adjustment/get_n2_adjustment_by_vessel/?vessel_id=${VesselID}`).then(response => {
            setTableDetails(response.data.filter((item: any) => item.approval_status === AdjustmentApprovalStatus.PENDING));
        }).catch(err => {
            setTableDetails([]);
        })
    }, [VesselID])

    return (
        <>
            <CardBody className='px-0 py-0 pb-0 mt-2'>
                <div className="table-responsive ">
                    <table className="table mb-0">
                        <thead className="table-light">
                            <tr>
                                <th className='p-2 align-middle sr-no-width'>#</th>
                                <th className='p-2 align-middle'>Duration</th>
                                <th className='p-2 align-middle'>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableDetails?.map((n2: any, index: number) => {
                                return (
                                    <tr key={index}>
                                        <td className='p-2 align-middle text-center'>{index + 1}</td>
                                        <td className='p-2 align-middle'>
                                            {n2?.end_report !== null ?
                                                <>
                                                    {n2?.start_date_time?.toString().substring(0, 10)}&nbsp;
                                                    {n2?.start_date_time?.toString().substring(11, 16)}&nbsp;to&nbsp;
                                                    {n2?.end_date_time?.toString().substring(0, 10)}&nbsp;
                                                    {n2?.end_date_time?.toString().substring(11, 16)}
                                                </>
                                                : <> Currently in progress </>
                                            }
                                        </td>
                                        <td className='p-2 align-middle'>
                                            <Link to="/n2_adjustment" color="primary" className='btn btn-primary'>
                                                Add Details
                                            </Link>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </CardBody>
        </>
    )
}

export default PendingLNGCargoDetails